module.exports = __webpack_public_path__ + "img/logo.8fc3d432.png";